import { useState } from 'react';
import { VIEWS } from '@bingads-webui-campaign-react/add-media-panel-crud-ad';

const WebsiteSuggestionTab = 2;

export const useImagePicker = () => {
  const [show, setShow] = useState(false);
  const [activeImagePickerPillIndex, setActiveImagePillIndex] = useState(0);
  const [selectedMediaPanelSource, setSelectedMediaPanelSource] = useState(VIEWS.LandingPage);

  const setDisplayImagePicker = (display) => {
    setShow(display);
    setActiveImagePillIndex(0);
    setSelectedMediaPanelSource(VIEWS.LandingPage);
  };

  const displayWebsiteSuggestionTab = () => {
    setShow(true);
    setActiveImagePillIndex(WebsiteSuggestionTab);
    setSelectedMediaPanelSource(VIEWS.WebsiteImage);
  };

  return {
    displayImagePicker: show,
    activeImagePickerPillIndex,
    setDisplayImagePicker,
    displayWebsiteSuggestionTab,
    selectedMediaPanelSource,
    setSelectedMediaPanelSource,
  };
};
